import { Outlet } from "react-router-dom";
import Header from "./Header/Header";

export default function UnityLayout({ setShowProjects, setShowHealth }: any) {

  return (
    <div className="h-full flex flex-col">
      <div id="navWrp" className="w-full flex-none bg-dark relative z-40">
        <Header setShowProjects={setShowProjects} setShowHealth={setShowHealth} />
      </div>
      <div className="relative overflow-hidden w-full h-full grow mx-auto">

        <Outlet />
      </div>
    </div>
  );
}
